import RenewSubscriptionModal from '../RenewSubscriptionModal';
import { useRef, useState } from 'react';
import { Alert, Avatar, Box, Button, IconButton, List, ListItem, ListItemText, Stack, Switch, TextField, Tooltip, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import SaveIcon from '@mui/icons-material/Save';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';

export default function ConfigVendedores({ store }) {
  const editBase = useRef(null);
  const [nombre, setNombre] = useState('');
  const [email, setEmail] = useState('');
  const [selected, setSelected] = useState('');
  const [error, setError] = useState('');
  const [paymentOpen, setPaymentOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const execute = async action => {
    setBusy(true); setError('');
    try { await action(); } catch (e) { setError(e.response?.data?.message || e.message); }
    finally { setBusy(false); }
  };
  if (!store.isOwner) return null;
  const sellers = store.config.vendedores || [];
  return <Box>
    <Typography variant="body2" mb={1}>{sellers.filter(v => v.activo).length} / {store.sellerLimit} vendedores activos. Hasta 3 gratis; cada extra USD 1/mes o USD 10/año.</Typography>
    <Button variant="outlined" onClick={()=>setPaymentOpen(true)} sx={{mb:2}}>Contratar o renovar vendedores extra</Button>
    <RenewSubscriptionModal open={paymentOpen} onClose={()=>setPaymentOpen(false)} appKey="corebase_crm_v1" appName="CoreBase CRM" />
    <Typography variant="body2" color="text.secondary" mb={1}>Para asignarte clientes, agrega tu nombre y el correo de tu cuenta como vendedor.</Typography>
    {error && <Alert severity="error" sx={{ mb: 1 }}>{error}</Alert>}
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} mb={1}>
      <TextField label="Nombre" value={nombre} onChange={e => setNombre(e.target.value)} size="small" />
      <TextField label="Correo de la cuenta" type="email" value={email} onChange={e => setEmail(e.target.value)} size="small" />
      <Tooltip title={selected ? 'Guardar vendedor' : 'Agregar vendedor'}><span><Button aria-label="Guardar vendedor" variant="outlined" disabled={busy || !nombre.trim() || !email.trim()} onClick={() => execute(async () => {
        await store.agregarVendedor(nombre, email, selected || undefined, editBase.current); setNombre(''); setEmail(''); setSelected('');
      })}>{selected ? <SaveIcon /> : <AddIcon />}</Button></span></Tooltip>
      {selected && <Tooltip title="Cancelar edicion"><IconButton aria-label="Cancelar edicion" disabled={busy} onClick={() => { setSelected(''); setNombre(''); setEmail(''); }}><CloseIcon /></IconButton></Tooltip>}
    </Stack>
    <List dense disablePadding>{sellers.map(v => <ListItem key={v.id} disableGutters>
      <Avatar sx={{ bgcolor: v.color || '#555', color: '#fff', width: 28, height: 28, mr: 1 }}>{v.nombre?.[0]?.toUpperCase()}</Avatar>
      <ListItemText primary={v.nombre} secondary={v.email || 'Correo pendiente'} sx={{ overflowWrap: 'anywhere' }} />
      <Tooltip title="Editar vendedor"><IconButton size="small" aria-label={`Editar ${v.nombre}`} onClick={() => { editBase.current = v; setSelected(v.id); setNombre(v.nombre); setEmail(v.email || ''); }}><EditIcon fontSize="small" /></IconButton></Tooltip>
      <Tooltip title={v.activo ? 'Desactivar vendedor' : 'Activar vendedor'}><Switch aria-label={`Acceso de ${v.nombre}`} checked={!!v.activo} disabled={busy || (!v.email && !v.activo)} onChange={() => execute(() => store.toggleVendedor(v.id))} size="small" /></Tooltip>
    </ListItem>)}</List>
  </Box>;
}
